
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { TranslateModule } from "@ngx-translate/core";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { NgForOf, NgIf, NgStyle } from "@angular/common";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'app-annual-plan-graph-dialog',
  templateUrl: './annual-plan-graph-dialog.component.html',
  styleUrls: ['./annual-plan-graph-dialog.scss'],
  imports: [
    TranslateModule,
    AppDatePipe,
    NgStyle,
    NgForOf,
    NgIf,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton
  ],
  standalone: true
})
export class AnnualPlanGraphDialogComponent {

    public week: any;

    constructor(
        public dialogRef: MatDialogRef<AnnualPlanGraphDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data:any) {
        this.week = data.week;
    }
}
